import React, { useState } from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import ViewUpsBarcodeDrawer from './ViewUpsBarcodeDrawer';
import { TagUPSBarcode } from '../../utils/analytics-tagging';
var ViewUPSBarcodeButton = function (_a) {
    var shipment = _a.shipment, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b;
    var _c = useState(false), displayDrawer = _c[0], setDisplayDrawer = _c[1];
    var openDrawer = function () {
        TagUPSBarcode();
        setDisplayDrawer(true);
    };
    var closeDrawer = function () { return setDisplayDrawer(false); };
    return (React.createElement("div", { className: "card-fix" },
        React.createElement(Button, { onClick: openDrawer, variant: variant, "data-testid": "view-barcode-button" },
            React.createElement("span", null, "View UPS Barcode")),
        React.createElement(ViewUpsBarcodeDrawer, { displayDrawer: displayDrawer, closeDrawer: closeDrawer, shipment: shipment })));
};
export default ViewUPSBarcodeButton;
